import { ComboContract, ProductContract } from 'models'

export const isMatchedProductByQueryText = (
    item: ProductContract | ComboContract,
    queryText: string,
) => {
    return (
        !queryText ||
        item.name?.toLowerCase().includes(queryText.toLowerCase()) ||
        item.refCode?.toLowerCase().includes(queryText.toLowerCase()) ||
        item.barcode?.toLowerCase().includes(queryText.toLowerCase())
    )
}
